module.exports = __webpack_public_path__ + "media/frontend/components/library/images/logo-2da9e8ffc0cb227ca668e4af6422a5fd.png";